import { jsx as _jsx } from "react/jsx-runtime";
import { Component_MetaPathwayOrder } from './Component_MetaPathwayOrder.js';
import { MUSTNeverHappenException, sortArray, ThisShouldNotHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_OrderGroup, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import { getOrderResourceType } from '../../../../_utils/get-resource-type.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { OrderPlacedSource } from '../../../../_analytics/types.js';
import { PopUp_OrderGroupsResolver } from '../../../pop-ups/PopUp_OrderGroupsResolver/PopUp_OrderGroupsResolver.js';
export class Component_MetaPathwayOrder_Group extends Component_MetaPathwayOrder {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.group = ModuleFE_Advisor_OrderGroup.cache.unique(nextProps.groupId);
        if (!state.group)
            throw new MUSTNeverHappenException(`Could not get order group for id ${nextProps.groupId}`);
        state.rtOrders = sortArray(nextProps.rtOrders, rtOrder => state.group.items.findIndex(pointer => pointer.id === rtOrder.orderId));
        const firstDBOrder = ModuleFE_Advisor_Action.cache.unique(state.rtOrders[0].orderId);
        if (!firstDBOrder)
            throw new MUSTNeverHappenException(`Group assigned an RTOrder with an unconnected dbOrder for id ${state.rtOrders[0].orderId}`);
        state.resourceType = getOrderResourceType(firstDBOrder);
        return state;
    }
    //######################### Abstract Logic #########################
    getVariant() {
        switch (this.state.resourceType) {
            case 'treatment':
                return 'metapathway-order-tertiary';
            case 'consult':
                return 'metapathway-order-secondary';
            default:
                return 'metapathway-order-primary';
        }
    }
    getIcon = () => {
        switch (this.state.resourceType) {
            case 'consult':
                return _jsx(ICONS.advisor_avn_consultation.component, {});
            case 'ekg':
                return _jsx(ICONS.advisor_avn_ekg.component, {});
            case 'imaging':
                return _jsx(ICONS.advisor_avn_imaging.component, {});
            case 'treatment':
                return _jsx(ICONS.advisor_avn_medication.component, {});
            default:
                return _jsx(ICONS.advisor_avn_labs.component, {});
        }
    };
    getLabel = () => {
        return `[${this.state.rtOrders.length}] ${this.state.group.name ?? this.state.group.label}`;
    };
    onClick = async (e) => {
        PopUp_OrderGroupsResolver.show(e, {
            groupIds: [this.state.group._id],
            limitToExistingRecommendedOrders: true,
            onSubmit: async (orderIdMapper) => {
                const orderId = orderIdMapper[this.state.group._id];
                const rtOrder = this.state.rtOrders.find(rtOrder => rtOrder.orderId === orderId);
                if (!rtOrder)
                    throw new ThisShouldNotHappenException(`Could not find rtOrder for order id ${orderId}`);
                await ModuleFE_RuntimeOrder.orderAll([rtOrder._id], undefined);
                const dbOrder = ModuleFE_Advisor_Action.cache.unique(rtOrder.orderId);
                ModuleFE_AdvisorAnalytics.trigger.orders.order_placed({
                    orderId: rtOrder.orderId,
                    orderLabel: dbOrder?.label ?? dbOrder?.name ?? this.state.group.label ?? this.state.group.name,
                    source: OrderPlacedSource.suggestedWorkup,
                });
            }
        });
    };
    getRuntimeOrderIds = () => {
        return this.state.rtOrders.map(rtOrder => rtOrder._id);
    };
}
//# sourceMappingURL=Component_MetaPathwayOrder_Group.js.map